import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

export const connectStream = (observableFnOrObj) => {
  const streamObj = (typeof observableFnOrObj === 'function')
    ? { anuket: observableFnOrObj }
    : observableFnOrObj;

  return (WrappedComponent) => {
    
    const {
      propTypes = {},
      excludeChangedProps = []
    } = WrappedComponent;

    return class extends React.Component {
      static propTypes = {
        changedProps: PropTypes.array,
      }

      static defaultProps = {
        changedProps: _(propTypes).map((prop, key) => key )
          .filter((key) => excludeChangedProps.indexOf(key) === -1)
          .value()
      }

      state = {};

      componentDidMount() {
        this._streamFn(this.props);
      }

      UNSAFE_componentWillReceiveProps(nextProps) {
        const { props } = this;
        const { changedProps } = props;

        if(changedProps.length > 0) {
          const diffProps = _.reduce(nextProps, (result, value, key) => {
            // If key is in changedProps and next value does not equal current value, it's different.
            const isDiff = changedProps.indexOf(key) > -1 && !_.isEqual(value, props[key]);

            return isDiff ? result.concat(key) : result;
          }, []);

          if (diffProps.length > 0) {
            this._streamFn(nextProps);
          }
        }
      }

      componentWillUnmount() {
        this._disposeStream();
        this._calledComponentWillUnmount = true;
      }

      _handleAsyncForEach(obj, callback) {
        Promise.all(Object.keys(obj).map(async (x) => callback(obj[x], x, obj)))
      }

      async _streamFn(props) {
        this._disposeStream();

        await this._handleAsyncForEach(streamObj, async (val, key) => {
          let objVal = val(props);

          //If it's a promise, wait for it to resolve
          if(objVal && objVal.then && typeof(objVal.then) === 'function') {
            objVal = await objVal;
          }

          this.subscribe[key] = objVal.subscribe(
            (msg) => {
              if(msg !== null && !this._calledComponentWillUnmount) {
                this.setState(
                  _.assign(
                    {},
                    { [key]: { isError: false }},
                    { [key]: msg }
                  )
                );
              }
            },
            (err) => {
              if (!this._calledComponentWillUnmount) {
                this.setState({ [key]: { isError: true, err }});
              }
            }
          );
        });
      }

      _disposeStream() {
        if (!this.subscribe) {
          this.subscribe = {};
        }

        _.forEach(streamObj, (val, key) => {
          if(this.subscribe[key] && this.subscribe[key].dispose) {
            this.subscribe[key].dispose();
          }
        });

      }

      render() {
        return <WrappedComponent {..._.assign({}, this.props, this.state)} />;
      }
    };
  };
};

export default connectStream;


/** WEBPACK FOOTER **
 ** ./lib/bastetjs/utils/connectStream.js
 **/